const typeTaskList = [
  'TODOS',
  'ALERTA DE VALIDADE',
  'ALERTA DE PERDA DE VENDA',
  'REABASTECIMENTO DE GÔNDOLA',
  'EMISSÃO DE ETIQUETA',
];

const statusTaskList = [
  'TODOS',
  'CANCELADAS',
  'FINALIZADAS',
  'PENDENTES',
  'SUBSTITUÍDAS',
];

const gondolaList = ['SIM', 'NÃO'];

const razaoList = [
  'DIFÍCIL ACESSO PARA O CLIENTE',
  'ESTAVA SEM PREÇO',
  'PRODUTO EXPOSTO ERRADO',
  'EAN ERRADO',
  'PREÇO NÃO ATRATIVO',
  'OUTROS MOTIVOS',
];

const estoqueList = ['SIM, REPOR', 'NÃO'];

export { statusTaskList, gondolaList, razaoList, estoqueList, typeTaskList };
